import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { LoginState, User } from './types';

export const actions: ActionTree<LoginState, RootState> = {
  login({ commit, state }, user: User): any {
    axios({
      url: '/login',
      method: 'POST',
      data: user,
    }).then(
      (response: AxiosResponse) => {
        const payload: User = response && response.data;
        // Launch sync for each smart tx allowed
        if ((payload as any).devices !== undefined) {
          (payload as any).devices.forEach((device: any) => {
            axios({
              url: `/devices/${device._id}/sync`,
              method: 'POST',
              timeout: -1,
            }).catch(() => {});
          });
        }
        commit('LOGIN_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('LOGIN_ERROR', payload);
      },
    );
  },
  logout({ commit, state }): any {
    axios({
      url: '/logout',
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: User = response && response.data;
        commit('LOGOUT_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('LOGOUT_ERROR', payload);
      },
    );
  },
  createPassword({ commit }, user: User): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: `/users/password/${user.activateCode}`,
        method: 'PUT',
        data: user,
      }).then(
        (response: AxiosResponse) => {
          const payload: User = response && response.data;
          commit('CREATE_PASSWORD_SUCCESS', payload);
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('CREATE_PASSWORD_ERROR', payload);
          reject();
        },
      );
    });
  },
  password({ commit }, user: User): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: '/password',
        method: 'PUT',
        data: user,
      }).then(
        () => {
          commit('CHANGE_PASSWORD_SUCCESS');
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('CHANGE_PASSWORD_ERROR', payload);
          reject();
        },
      );
    });
  },
  lostPassword({ commit }, user: User): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: '/lostpassword?template=3f',
        method: 'POST',
        data: user,
      }).then(
        () => {
          commit('LOST_PASSWORD_SUCCESS');
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('LOST_PASSWORD_ERROR', payload);
          reject();
        },
      );
    });
  },
};
